// Resuelve el token de la solicitud de codeudor tanto desde la query string
// de la ruta (modo history: /?token=xxx) como desde el fragmento/hash del
// enlace enviado por correo (#/solicitud/codeudor?token=xxx).
export function resolveToken(route) {
  const q = route && route.query && route.query.token;
  if (q) return q;
  const hash = (typeof window !== 'undefined' && window.location.hash) || '';
  const i = hash.indexOf('?');
  if (i >= 0) return new URLSearchParams(hash.slice(i + 1)).get('token') || null;
  return null;
}
